/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/component-selector */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { allowedLogoFiles, emailPattern, noWhitespaceInRequiredValidator } from '../../../shared/constants';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'company-form',
	templateUrl: './company-form.component.html',
	styleUrl: './company-form.component.css'
})
export class CompanyFormComponent implements OnInit {
	moduleForm!: FormGroup;
	showLoader = false;
	pageLoading = false;
	@Input() uId: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;
	file!: File | null;
	fileError = false;
	fileMsg = "";
	co_logo: any = null;
	public File_Storage_URL = environment.File_Storage_URL;
	allowedLogoFiles = allowedLogoFiles;
	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.moduleForm = this.formBuilder.group({
			com_name: [null/* , [Validators.required, noWhitespaceInRequiredValidator] */],
			comp_address: [null/* , [Validators.required, noWhitespaceInRequiredValidator] */],
			comp_full_address: [null],
			EmailId: [null,/*  [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(emailPattern)] */],
		});
		/* this.apiService.getUserAccess().subscribe((data:any) => {
		try {
		let accessObj:any = JSON.parse(data.res[0].UserModuleAccess);
		this.UserModuleAccess = accessObj["Company"];
		} catch (error) {}
		},(error:any) => {
		this.UserModuleAccess = "NoAccess";
		}); */
	}

	get f() { return this.moduleForm.controls; }

	ngOnInit(): void {
		if (this.uId) {
			this.getDetails();
		}
	}

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getCompany({ id: this.uId }).subscribe({
			next: (data: any) => {
				const obj = data.data;
				this.moduleForm.setValue({
					com_name: obj.com_name,
					comp_address: obj.comp_address,
					comp_full_address: obj.comp_full_address,
					EmailId: obj.EmailId
				});
				this.co_logo = obj.co_logo;
				this.f.com_name.disable();
				this.f.comp_address.disable();
				this.f.EmailId.disable();
			}, error: (error) => {
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const formData = new FormData();
		if (this.uId) {
			formData.append("id", this.uId);
		} else {
			formData.append("com_name", this.f.com_name.value);
			formData.append("comp_address", this.f.comp_address.value);
			formData.append("EmailId", this.f.EmailId.value);
			if (this.file) {
				formData.append("logo", this.file);
			} else {
				formData.append("logo", "");
			}
		}
		formData.append("comp_full_address", this.f.comp_full_address.value);
		this.showLoader = true;
		this.apiService.createUpdateCompany(formData).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg = "Something went wrong.";
				if (error.status == 400) {
					errorMsg = error.error;
					if (typeof errorMsg == 'object') {
						for (const [key, value] of Object.entries(errorMsg)) {
							const val: any = value;
							if (val[0] == "This field must be unique.") {
								val[0] = "Already exists";
							}
							if (this.moduleForm.controls[key]) {
								this.moduleForm.controls[key].setErrors({ incorrect: true });
								this.customError[key] = val[0];
								const selector = "#" + key;
								try {
									$('html, body').animate({
										scrollTop: $(selector).offset().top - 60 + 'px'
									}, 'fast');
								} catch (error) { }
								$(selector).focus();
							} else {
								this.toastr.error(key + ":" + val[0], 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}
						}
						return;
					} else {
						errorMsg = "Company already exists";
					}
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	public onFileSelect(file) {
		this.file = file;
	}
}
